import {
  Checkbox as MuiCheckbox,
  type CheckboxProps as MuiCheckboxProps,
  FormControlLabel as MuiFormControlLabel,
  type FormControlLabelProps as MuiFormControlLabelProps
} from "@mui/material";

export type CheckboxProps = MuiCheckboxProps;
export type FormControlLabelProps = MuiFormControlLabelProps;

export const Checkbox = MuiCheckbox;
export const FormControlLabel = MuiFormControlLabel;
